var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingCommentsNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,16A16,16,0,1,1,16,0,16,16,0,0,1,32,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.81,13.89a1.11,1.11,0,0,1,.84-.39,1.07,1.07,0,0,1,.78.34L16,17.53l3.57-3.69a1.08,1.08,0,0,1,1.62.05,1.34,1.34,0,0,1-.05,1.77l-4.35,4.5a1.09,1.09,0,0,1-1.58,0l-4.35-4.5A1.34,1.34,0,0,1,10.81,13.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingCommentsNext);
export default __webpack_public_path__ + "static/media/meeting-comments-next.900c8a3c8df095027eba6e18780959a3.svg";
export { ForwardRef as ReactComponent };